import { BASE_URL } from "@/constants/common";

export const uploadFile = async (file: File): Promise<{ file_url: string }> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(`${BASE_URL}/upload_file`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) throw new Error("Failed to upload file");

  return response.json();
};
